/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface SellerModel {

        "code"?: number;

        "name"?: string;

        "email"?: string;
    }

}
